export const HOME = {
  emergentLink: "home-emergent-link",
  ctaBrowse: "hero-cta-browse",
  ctaAdvisor: "hero-cta-advisor",
};

export const NAV = {
  brand: "nav-brand",
  directory: "nav-directory",
  rankings: "nav-rankings",
  compare: "nav-compare",
  categories: "nav-categories",
  advisor: "nav-advisor",
  langToggle: "nav-lang-toggle",
  compareBadge: "nav-compare-badge",
};

export const DIRECTORY = {
  search: "directory-search-input",
  sort: "directory-sort-select",
  region: "directory-region-select",
  audience: "directory-audience-select",
  appCard: (slug) => `app-card-${slug}`,
  compareToggle: (slug) => `app-compare-toggle-${slug}`,
};

export const APP_DETAIL = {
  visit: "app-detail-visit",
  addCompare: "app-detail-add-compare",
};

export const COMPARE = {
  clear: "compare-clear-all",
  table: "compare-table",
};

export const ADVISOR = {
  input: "advisor-input",
  send: "advisor-send-button",
  example: (i) => `advisor-example-${i}`,
  newChat: "advisor-new-chat",
};
